export type TariffVariant = 'Simple' | 'Basic' | 'Advanced'

export type TariffPeriod = 'Month' | 'HalfYear' | 'Year'

export type ServiceOrderStatus = 'New' | 'Paid' | 'Cancelled' | 'Error'

export const TariffTypes = {
    Simple: 'Простой',
    Basic: 'Базовый',
    Advanced: 'Расширенный'
}